import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=fb9160f6&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=fb9160f6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb9160f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb9160f6')) {
      api.createRecord('fb9160f6', component.options)
    } else {
      api.reload('fb9160f6', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=fb9160f6&scoped=true", function () {
      api.rerender('fb9160f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/User/ChangePassword.vue"
export default component.exports